/* eslint-disable */
import {querySelector} from "app/lib/helperjs";

const OVERLAY_ID_NAME = '#body-overlay';

export class Overlay {
    static toggle() {
        const overlay = Overlay.getDOM;

        return overlay.classList.toggle('visible');
    }

    static get getDOM() {
        return window.document.querySelector(OVERLAY_ID_NAME);
    }
}
